<template>
  <b-badge pill class="form-badge" :class="variant">
    {{ title }}
  </b-badge>
</template>

<script>
export default {
  name: "FormStatusBadge",
  props: ["status", "fullTitle"],
  computed: {
    variant() {
      return this.status ? "badge-completed" : "badge-pending";
    },
    title() {
      switch (this.status) {
        case true:
          return this.fullTitle ? "Completed" : "C";

        default:
          return this.fullTitle ? "Pending" : "P";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.form-badge {
  padding: 5px 10px;
  font-size: 1em;
  width: 100%;
  max-width: 100px;

  &.badge-completed {
    background: #ccf9cf;
    color: #01be0e;
  }

  &.badge-pending {
    background: #fff3ca;
    color: #ffc300;
  }
}
</style>
